module.exports = __webpack_public_path__ + "img/grade-5.4f1bfb27.png";